import { rootUrl as baseUrl } from './shared';

export const generateWebPageSchema = ({ path, hasBreadcrumbs }) => {
  const url = (baseUrl + path).toLocaleLowerCase();
  const breadcrumb = hasBreadcrumbs
    ? {
        breadCrumb: {
          '@id': `${url}#breadcrumb`
        }
      }
    : {};
  return {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    '@id': `${url}#webpage`,
    url: `${url}`,
    inLanguage: 'en',
    isPartOf: {
      '@id': `${baseUrl}/#website`
    },
    ...breadcrumb
  };
};
